var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "trvm-container" },
    [
      _c("header", { staticClass: "trvm-header" }, [
        _c("h1", { staticClass: "trvm-title" }, [_vm._v("旅途管理")]),
        _vm._v(" "),
        _c("span", { staticClass: "trvm-sub" }, [
          _vm._v("数据源：旅途主页（proj.travel）"),
        ]),
        _vm._v(" "),
        _vm.me.username
          ? _c("span", { staticClass: "trvm-user" }, [
              _vm._v(_vm._s(_vm.me.username) + " · " + _vm._s(_vm.me.role)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "trvm-actions" },
          [
            _c(
              "router-link",
              { staticClass: "trvm-link", attrs: { to: "/travel" } },
              [_vm._v("返回主页")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { size: "small", icon: "el-icon-brush" },
                on: { click: _vm.openOrphans },
              },
              [_vm._v("清理未使用文件")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.logout } },
              [_vm._v("退出登录")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { size: "small", type: "primary", icon: "el-icon-plus" },
                on: { click: _vm.openCreate },
              },
              [_vm._v("新增行程")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "trvm-filters" },
        [
          _c("el-input", {
            staticClass: "f-id",
            attrs: { size: "small", clearable: "", placeholder: "ID" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.search.apply(null, arguments)
              },
            },
            model: {
              value: _vm.filters.id,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "id", $$v)
              },
              expression: "filters.id",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "f-w",
              attrs: {
                size: "small",
                clearable: "",
                filterable: "",
                placeholder: "标题",
              },
              on: { change: _vm.search, clear: _vm.search },
              model: {
                value: _vm.filters.title,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "title", $$v)
                },
                expression: "filters.title",
              },
            },
            _vm._l(_vm.titleOptions, function (t) {
              return _c("el-option", { key: t, attrs: { label: t, value: t } })
            }),
            1
          ),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "f-w",
            attrs: { size: "small", clearable: "", placeholder: "副标题" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.search.apply(null, arguments)
              },
            },
            model: {
              value: _vm.filters.subtitle,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "subtitle", $$v)
              },
              expression: "filters.subtitle",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "f-w",
              attrs: {
                size: "small",
                clearable: "",
                filterable: "",
                placeholder: "作者",
              },
              on: { change: _vm.search, clear: _vm.search },
              model: {
                value: _vm.filters.author,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "author", $$v)
                },
                expression: "filters.author",
              },
            },
            _vm._l(_vm.authorOptions, function (a) {
              return _c("el-option", { key: a, attrs: { label: a, value: a } })
            }),
            1
          ),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "f-w",
            attrs: { size: "small", clearable: "", placeholder: "内容" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.search.apply(null, arguments)
              },
            },
            model: {
              value: _vm.filters.content,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "content", $$v)
              },
              expression: "filters.content",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "f-s",
              attrs: { size: "small" },
              on: { change: _vm.search },
              model: {
                value: _vm.filters.order,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "order", $$v)
                },
                expression: "filters.order",
              },
            },
            [
              _c("el-option", { attrs: { label: "新→旧", value: "desc" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "旧→新", value: "asc" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                icon: "el-icon-search",
                loading: _vm.loading,
              },
              on: { click: _vm.search },
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.resetFilters } },
            [_vm._v("重置")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.error
        ? _c("el-alert", {
            staticClass: "trvm-error",
            attrs: {
              type: "error",
              title: _vm.error,
              "show-icon": "",
              closable: false,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loadingOptions
        ? _c("div", { staticClass: "trvm-loading-options" }, [
            _vm._v("筛选选项加载中…"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "trvm-table-wrap",
        },
        [
          _c("table", { staticClass: "trvm-table" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm._l(_vm.items, function (row, idx) {
                  return _c("tr", { key: (row.id || "") + idx }, [
                    _c(
                      "td",
                      {
                        staticClass: "c-title",
                        attrs: { "data-label": "标题" },
                      },
                      [_vm._v(_vm._s(row.title))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c-subtitle",
                        attrs: { "data-label": "副标题" },
                      },
                      [_vm._v(_vm._s(row.subtitle || "—"))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c-author",
                        attrs: { "data-label": "作者" },
                      },
                      [_vm._v(_vm._s(row.author || "—"))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c-content",
                        attrs: { "data-label": "内容", title: row.content },
                      },
                      [_vm._v(_vm._s(_vm.excerpt(row.content, 56)))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c-media",
                        attrs: { "data-label": "附件" },
                      },
                      [
                        row.track && row.track.points
                          ? _c("span", { staticClass: "media-tag" }, [
                              _c("i", { staticClass: "el-icon-map-location" }),
                              _vm._v(_vm._s(row.track.points.length)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        (row.images || []).length
                          ? _c("span", { staticClass: "media-tag" }, [
                              _c("i", {
                                staticClass: "el-icon-picture-outline",
                              }),
                              _vm._v(_vm._s(row.images.length)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        (row.videos || []).length
                          ? _c("span", { staticClass: "media-tag" }, [
                              _c("i", { staticClass: "el-icon-video-camera" }),
                              _vm._v(_vm._s(row.videos.length)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !(row.track && row.track.points) &&
                        !(row.images || []).length &&
                        !(row.videos || []).length
                          ? _c("span", { staticClass: "media-none" }, [
                              _vm._v("—"),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c-time",
                        attrs: { "data-label": "收录时间" },
                      },
                      [_vm._v(_vm._s(_vm.tsToDate(row.createtime)))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "c-time",
                        attrs: { "data-label": "录入时间" },
                      },
                      [_vm._v(_vm._s(_vm.tsToDate(row.recordtime)))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "c-op", attrs: { "data-label": "操作" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openEdit(row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.removeItem(row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ],
                      1
                    ),
                  ])
                }),
                _vm._v(" "),
                !_vm.loading && _vm.items.length === 0
                  ? _c("tr", [
                      _c(
                        "td",
                        { staticClass: "trvm-empty", attrs: { colspan: "8" } },
                        [_vm._v("暂无数据")]
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "trvm-pager" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: _vm.pagerLayout,
              "pager-count": _vm.isMobile ? 5 : 7,
              total: _vm.total,
              "current-page": _vm.page,
              "page-size": _vm.pageSize,
              "page-sizes": [10, 20, 50],
            },
            on: {
              "update:currentPage": function ($event) {
                _vm.page = $event
              },
              "update:current-page": function ($event) {
                _vm.page = $event
              },
              "update:pageSize": function ($event) {
                _vm.pageSize = $event
              },
              "update:page-size": function ($event) {
                _vm.pageSize = $event
              },
              "current-change": _vm.query,
              "size-change": _vm.onSizeChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.form.id ? "编辑行程" : "新增行程",
            visible: _vm.dialogVisible,
            width: _vm.dialogWidth,
            "custom-class": "mng-form-dialog",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onDialogClose,
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.cancelDialog },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        loading: _vm.saving,
                      },
                      on: { click: _vm.save },
                    },
                    [_vm._v("保存")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.form,
                "label-position": _vm.isMobile ? "top" : "right",
                "label-width": "90px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "标题", required: "" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "如：环青海湖骑行" },
                    model: {
                      value: _vm.form.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "title", $$v)
                      },
                      expression: "form.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "副标题" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "副标题（可空）" },
                    model: {
                      value: _vm.form.subtitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "subtitle", $$v)
                      },
                      expression: "form.subtitle",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "作者" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "作者（可空，缺省我）" },
                    model: {
                      value: _vm.form.author,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "author", $$v)
                      },
                      expression: "form.author",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "行记", required: "" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 7,
                      placeholder: "旅途见闻，多行请换行",
                    },
                    model: {
                      value: _vm.form.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "content", $$v)
                      },
                      expression: "form.content",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "轨迹" } }, [
                _c("div", { staticClass: "trvm-block" }, [
                  _vm.form.track
                    ? _c(
                        "div",
                        { staticClass: "track-info" },
                        [
                          _c("span", { staticClass: "track-name" }, [
                            _vm._v(_vm._s(_vm.form.track.name || "轨迹")),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "track-meta" }, [
                            _vm._v(
                              _vm._s((_vm.form.track.points || []).length) +
                                " 个坐标点 · " +
                                _vm._s(_vm.form.track.format || "")
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "text" },
                              on: { click: _vm.removeTrack },
                            },
                            [_vm._v("移除")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "upload-row" },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            "show-file-list": false,
                            "http-request": _vm.handleTrackUpload,
                            accept: ".gpx,.kml,.tcx",
                            disabled: _vm.uploadStat.track.count > 0,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                loading: _vm.uploadStat.track.count > 0,
                                icon: "el-icon-upload2",
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.uploadStat.track.count > 0
                                      ? "上传解析中 " +
                                          _vm.uploadStat.track.percent +
                                          "%"
                                      : _vm.form.track
                                      ? "替换轨迹文件"
                                      : "上传轨迹文件"
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "upload-hint" }, [
                        _vm._v("支持 GPX / KML / TCX，上传后自动解析坐标点"),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "图片" } }, [
                _c("div", { staticClass: "trvm-block" }, [
                  _c(
                    "div",
                    { staticClass: "media-grid" },
                    [
                      _vm._l(_vm.form.images, function (img, i) {
                        return _c(
                          "div",
                          { key: "img" + i, staticClass: "media-cell" },
                          [
                            _c("div", { staticClass: "media-thumb" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm.mediaUrl(img.thumbUrl || img.url),
                                  alt: img.desc || img.name,
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "media-del",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeImage(i)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-close" })]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "media-desc",
                              attrs: {
                                size: "mini",
                                placeholder: "描述（可空）",
                                maxlength: "60",
                              },
                              model: {
                                value: img.desc,
                                callback: function ($$v) {
                                  _vm.$set(img, "desc", $$v)
                                },
                                expression: "img.desc",
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.imageUploads, function (job) {
                        return _c(
                          "div",
                          {
                            key: "up" + job.id,
                            staticClass: "media-cell is-uploading",
                          },
                          [
                            _c("div", { staticClass: "media-thumb" }, [
                              _c("img", {
                                attrs: { src: job.previewUrl, alt: job.name },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "media-upmask",
                                  class: { "is-error": job.status === "error" },
                                },
                                [
                                  job.status === "error"
                                    ? [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-warning-outline",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "media-uppct" },
                                          [_vm._v("失败")]
                                        ),
                                      ]
                                    : [
                                        _c("i", {
                                          staticClass: "el-icon-loading",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "media-uppct" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                job.total > 0
                                                  ? Math.min(
                                                      99,
                                                      Math.floor(
                                                        (job.loaded /
                                                          job.total) *
                                                          100
                                                      )
                                                    )
                                                  : 0
                                              ) + "%"
                                            ),
                                          ]
                                        ),
                                      ],
                                ],
                                2
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "media-upname",
                                attrs: { title: job.name },
                              },
                              [_vm._v(_vm._s(job.name))]
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "el-upload",
                        {
                          staticClass: "media-add",
                          attrs: {
                            "show-file-list": false,
                            "http-request": _vm.handleImageUpload,
                            accept: "image/*",
                            multiple: "",
                            disabled: _vm.imageUploads.length > 0,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "media-add-box",
                              class: {
                                "is-loading": _vm.imageUploads.length > 0,
                              },
                            },
                            [
                              _vm.imageUploads.length > 0
                                ? [
                                    _c("i", { staticClass: "el-icon-loading" }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "media-add-pct" },
                                      [
                                        _vm._v(
                                          "剩 " +
                                            _vm._s(_vm.imageUploads.length) +
                                            " 张"
                                        ),
                                      ]
                                    ),
                                  ]
                                : _c("i", { staticClass: "el-icon-plus" }),
                            ],
                            2
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "upload-hint" }, [
                    _vm._v(
                      _vm._s(
                        _vm.imageUploads.length > 0
                          ? "正在逐张上传，请稍候…"
                          : "支持多张图片，可逐张删除，并为每张填写描述"
                      )
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "视频" } }, [
                _c("div", { staticClass: "trvm-block" }, [
                  _vm.form.videos.length || _vm.videoUploads.length
                    ? _c(
                        "div",
                        { staticClass: "video-list" },
                        [
                          _vm._l(_vm.form.videos, function (v, i) {
                            return _c(
                              "div",
                              { key: "vid" + i, staticClass: "video-item" },
                              [
                                _c("video", {
                                  staticClass: "video-thumb",
                                  attrs: {
                                    src: _vm.mediaUrl(v.url),
                                    controls: "",
                                    preload: "metadata",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "video-name",
                                    attrs: { title: v.name },
                                  },
                                  [_vm._v(_vm._s(v.name || "视频"))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "media-del",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeVideo(i)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "el-icon-close" })]
                                ),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.videoUploads, function (job) {
                            return _c(
                              "div",
                              {
                                key: "vup" + job.id,
                                staticClass: "video-item is-uploading",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "video-thumb video-upthumb",
                                    class: {
                                      "is-error": job.status === "error",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      class:
                                        job.status === "error"
                                          ? "el-icon-warning-outline"
                                          : "el-icon-loading",
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "video-uppct" }, [
                                      _vm._v(
                                        _vm._s(
                                          job.status === "error"
                                            ? "失败"
                                            : (job.total > 0
                                                ? Math.min(
                                                    99,
                                                    Math.floor(
                                                      (job.loaded / job.total) *
                                                        100
                                                    )
                                                  )
                                                : 0) + "%"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "video-name",
                                    attrs: { title: job.name },
                                  },
                                  [_vm._v(_vm._s(job.name))]
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "upload-row" },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            "show-file-list": false,
                            "http-request": _vm.handleVideoUpload,
                            accept: "video/*",
                            multiple: "",
                            disabled: _vm.videoUploads.length > 0,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                loading: _vm.videoUploads.length > 0,
                                icon: "el-icon-upload2",
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.videoUploads.length > 0
                                      ? "上传中，剩 " +
                                          _vm.videoUploads.length +
                                          " 个"
                                      : "上传视频"
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "upload-hint" }, [
                        _vm._v(
                          _vm._s(
                            _vm.videoUploads.length > 0
                              ? "正在逐个上传，请稍候…"
                              : "支持多个视频"
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "收录时间" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      "value-format": "timestamp",
                      placeholder: "收录时间",
                    },
                    model: {
                      value: _vm.form.createMs,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "createMs", $$v)
                      },
                      expression: "form.createMs",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "录入时间" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      "value-format": "timestamp",
                      placeholder: "录入时间",
                    },
                    model: {
                      value: _vm.form.recordMs,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "recordMs", $$v)
                      },
                      expression: "form.recordMs",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "照片时间校正" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      step: 1,
                      precision: 0,
                      "controls-position": "right",
                      placeholder: "秒，正=照片往后",
                    },
                    model: {
                      value: _vm.form.photoOffsetSec,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "photoOffsetSec", $$v)
                      },
                      expression: "form.photoOffsetSec",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "upload-hint" }, [
                    _vm._v(
                      "单位秒：正值=照片沿轨迹后移，负值=前移；空或 0 表示不校正"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "未使用的文件",
            visible: _vm.orphanVisible,
            width: _vm.dialogWidth,
            "custom-class": "mng-form-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.orphanVisible = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.orphanVisible = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "danger",
                        plain: "",
                        disabled: !_vm.orphanSelected.length,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.removeOrphans(false)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "删除选中" +
                          _vm._s(
                            _vm.orphanSelected.length
                              ? "（" + _vm.orphanSelected.length + "）"
                              : ""
                          )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "danger",
                        disabled: !_vm.orphanFiles.length,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.removeOrphans(true)
                        },
                      },
                    },
                    [_vm._v("全部删除")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            { staticClass: "orphan-head" },
            [
              _c("span", { staticClass: "orphan-sum" }, [
                _vm._v("共 "),
                _c("b", [_vm._v(_vm._s(_vm.orphanFiles.length))]),
                _vm._v(" 个 · 合计 " + _vm._s(_vm.formatSize(_vm.orphanSize))),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    icon: "el-icon-refresh",
                    loading: _vm.orphanLoading,
                  },
                  on: { click: _vm.loadOrphans },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "orphan-tip" }, [
            _vm._v(
              "这些文件已不被任何行程或笔记记录引用（多为取消上传、删图、删记录后残留），删除后不可恢复。"
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.orphanLoading,
                  expression: "orphanLoading",
                },
              ],
              staticClass: "orphan-table-wrap",
            },
            [
              _vm.orphanFiles.length
                ? _c("table", { staticClass: "orphan-table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c(
                          "th",
                          { staticClass: "oc-check" },
                          [
                            _c("el-checkbox", {
                              attrs: {
                                value: _vm.allOrphanSelected,
                                indeterminate: _vm.orphanIndeterminate,
                                "aria-label": "全选未使用文件",
                              },
                              on: { change: _vm.toggleAllOrphans },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("th", { staticClass: "oc-thumb" }, [_vm._v("预览")]),
                        _vm._v(" "),
                        _c("th", { staticClass: "oc-name-h" }, [
                          _vm._v("文件名"),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "oc-size" }, [_vm._v("大小")]),
                        _vm._v(" "),
                        _c("th", { staticClass: "oc-time" }, [
                          _vm._v("修改时间"),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.orphanFiles, function (f) {
                        return _c(
                          "tr",
                          {
                            key: f.name,
                            class: { "is-sel": _vm.orphanChecked[f.name] },
                            on: {
                              click: function ($event) {
                                return _vm.toggleOrphan(f.name)
                              },
                            },
                          },
                          [
                            _c(
                              "td",
                              {
                                staticClass: "oc-check",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _c("el-checkbox", {
                                  model: {
                                    value: _vm.orphanChecked[f.name],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.orphanChecked, f.name, $$v)
                                    },
                                    expression: "orphanChecked[f.name]",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "oc-thumb",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _vm.orphanKind(f.name) === "image"
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "orphan-thumb is-img",
                                        attrs: {
                                          type: "button",
                                          title: "预览 " + f.name,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.previewOrphan(f)
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.orphanThumbUrl(f),
                                            alt: "",
                                            loading: "lazy",
                                          },
                                          on: {
                                            error: function ($event) {
                                              return _vm.onThumbError(f)
                                            },
                                          },
                                        }),
                                      ]
                                    )
                                  : _c(
                                      "button",
                                      {
                                        staticClass: "orphan-thumb is-icon",
                                        attrs: {
                                          type: "button",
                                          title: "预览 " + f.name,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.previewOrphan(f)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          class: _vm.orphanKindIcon(f.name),
                                        }),
                                      ]
                                    ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "oc-name",
                                attrs: { title: f.name },
                              },
                              [
                                _c("span", { staticClass: "oc-name-text" }, [
                                  _vm._v(_vm._s(f.name)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "oc-kind",
                                    class: "k-" + _vm.orphanKind(f.name),
                                  },
                                  [_vm._v(_vm._s(_vm.orphanKindLabel(f.name)))]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", { staticClass: "oc-size" }, [
                              _vm._v(_vm._s(_vm.formatSize(f.size))),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "oc-time" }, [
                              _vm._v(_vm._s(_vm.formatTime(f.modTime))),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _c("div", { staticClass: "orphan-empty" }, [
                    _vm._v("没有未使用的文件"),
                  ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "文件预览",
            visible: _vm.previewVisible,
            width: _vm.dialogWidth,
            "custom-class": "mng-form-dialog orphan-preview-dialog",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
            closed: _vm.onPreviewClosed,
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a",
                    {
                      staticClass: "op-open-link",
                      attrs: {
                        href: _vm.previewFile
                          ? _vm.orphanFileUrl(_vm.previewFile.name)
                          : "",
                        target: "_blank",
                        rel: "noopener",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", icon: "el-icon-view" } },
                        [_vm._v("新窗口打开")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.previewVisible = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.previewFile
            ? _c("div", { staticClass: "op-wrap" }, [
                _c("div", { staticClass: "op-stage" }, [
                  _vm.previewKind === "image"
                    ? _c("img", {
                        staticClass: "op-img",
                        attrs: {
                          src: _vm.orphanFileUrl(_vm.previewFile.name),
                          alt: _vm.previewFile.name,
                        },
                      })
                    : _vm.previewKind === "video"
                    ? _c("video", {
                        staticClass: "op-video",
                        attrs: {
                          src: _vm.orphanFileUrl(_vm.previewFile.name),
                          controls: "",
                          autoplay: "",
                        },
                      })
                    : _c("div", { staticClass: "op-void" }, [
                        _c("i", {
                          class: _vm.orphanKindIcon(_vm.previewFile.name),
                        }),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "轨迹文件（" +
                              _vm._s(_vm.orphanExt(_vm.previewFile.name)) +
                              "）无法在浏览器中直接预览"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "op-void-tip" }, [
                          _vm._v("可用下方「新窗口打开」查看内容。"),
                        ]),
                      ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "op-meta" }, [
                  _c(
                    "span",
                    {
                      staticClass: "op-name",
                      attrs: { title: _vm.previewFile.name },
                    },
                    [_vm._v(_vm._s(_vm.previewFile.name))]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "op-info" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.orphanKindLabel(_vm.previewFile.name)) +
                        " · " +
                        _vm._s(_vm.formatSize(_vm.previewFile.size)) +
                        " · " +
                        _vm._s(_vm.formatTime(_vm.previewFile.modTime)) +
                        "\n        "
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "c-title" }, [_vm._v("标题")]),
        _vm._v(" "),
        _c("th", { staticClass: "c-subtitle" }, [_vm._v("副标题")]),
        _vm._v(" "),
        _c("th", { staticClass: "c-author" }, [_vm._v("作者")]),
        _vm._v(" "),
        _c("th", { staticClass: "c-content" }, [_vm._v("内容")]),
        _vm._v(" "),
        _c("th", { staticClass: "c-media" }, [_vm._v("附件")]),
        _vm._v(" "),
        _c("th", { staticClass: "c-time" }, [_vm._v("收录时间")]),
        _vm._v(" "),
        _c("th", { staticClass: "c-time" }, [_vm._v("录入时间")]),
        _vm._v(" "),
        _c("th", { staticClass: "c-op" }, [_vm._v("操作")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }